import React from 'react';

// Filled-green "★ MAIN" pill. Same shape/size family as RouteBadge, sits left
// of titles (design-handoff.md B.1 / E.2).

const MainTag: React.FC = () => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 3,
      padding: '2px 8px',
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.4,
      color: '#ffffff',
      background: '#157a55',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    }}
  >
    ★ Main
  </span>
);

export default MainTag;
